export default __webpack_public_path__ + "static/es-81179245d0cbf63f128b7b4012d140a2.svg";